<template>
  <div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <form class="clearfix row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{$t('settingCurrency.currency')}}</label>
          <div class="row">
            <el-select class="col-md-12" placeholder=" - Select Currency - " filterable v-model="model.currency_iso">
              <el-option v-for="cr in currencies"
                          :value="cr.iso"
                          :label="displayCurrecy(cr)"
                          :key="cr.iso"></el-option>
            </el-select>
          </div>
        </div>
        <!--    <div class="form-group">
          <label>Shop format</label>
          <div class="row">
            <el-select class="col-md-12" placeholder=" - Select Currency - " filterable v-model="model.currency_display_format">
              <el-option v-for="(label, id) in currenciesformat"
                          :value="id" :label="label" :key="id + label"></el-option>
            </el-select>
          </div>
        </div> -->
        <div class="form-group">
          <button class="btn btn-success btn-fill" @click.prevent="validate">{{$t('general.update')}}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input
    },
    props: {
      currencylist: {},
      currencyformatlist: {},
      modeldata: {}
    },
    watch: {
      currencylist (value) {
        this.currencies = value
      },
      currencyformatlist (value) {
        this.currenciesformat = value
      },
      modeldata (value) {
        this.model = value
      }
    },
    data () {
      return {
        model: [],
        currencies: [], // this.countries
        currenciesformat: [],
        modelValidate: {
          name: {required: true},
          email: {required: true, email: true},
          phone: {required: true},
          street: {required: true},
          city: {required: true},
          state: {required: true},
          country: {required: true}
        },
        loading: false
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      displayCurrecy (cr) {
        var name = this.getCurrencySymbol(cr.iso)
        return name + ' - ' + cr.name
      },
      saveDetails () {
        this.$nextTick(function () { this.loading = true })
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'currency_display_format': 1,
          'currency_iso': this.model.currency_iso
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            self.$session.set('selectedCompanyData', response.data[0])
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('settingCurrency.saveMsg'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/Currency.vue